import { validateProps } from '../utils';
export const isValidBusiness = properties => {
  const ans = validateProps(properties, ['id', 'displayName']);
  return ans;
};
//# sourceMappingURL=Business.js.map